
import EDButton from '../../../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIcon from '../../../../../../../BaseComponents/Icon/EDIcon';
import { useIsSmallScreen } from '../../../../../../../Hooks/useFullscreenView';

interface IProps {
  onClick: () => void;
}

const ShowFastRegButton: React.FC<React.PropsWithChildren<IProps>> = props => {
  const isSmallScreen = useIsSmallScreen();

  return (
    <>
      {!isSmallScreen && (
        <EDButton
          flat
          label="Snabbregistrering"
          icon={<EDIcon color="primary" iconType="bolt" />}
          onClick={props.onClick}
        />
      )}
    </>
  );
};

export default ShowFastRegButton;
